import React from 'react'
import { SearchBlockMobile } from 'src/shared/ui/mobile/search-block'
import {
    $isOpenedSearchSection,
    closeSearchSection,
    openSearchSection,
    useOnChangeSearchText,
    useSearchText
} from 'src/features/search-goods/model'
import { SuggestionsSearchMobile } from 'src/features/suggestions/ui/mobile'
import styled from 'styled-components'
import ButtonTransparent from '@shared/ButtonTransparent/ButtonTransparent'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import { ButtonElement } from '@shared/ButtonTransparent/ButtonTransparent.styled'
import { useEvent, useStore } from 'effector-react'
import { searchSuggestion } from 'src/features/suggestions/model'

const Container = styled.div``

interface SuggestionsSearchBlockProps {
    isVisible: boolean
}

export const SuggestionsSearchBlock = styled.div<SuggestionsSearchBlockProps>`
    display: ${(props) => (props.isVisible ? 'inline-block' : 'none')};
    position: absolute;
    width: 100%;
    left: 0;
    height: calc(100% - 41px);
    background-color: ${ThemeColors.white};
    z-index: 68;
`
export const SearchBlock = styled.div`
    display: flex;

    ${ButtonElement} {
        font-weight: normal;
        padding: 0 5px;
    }
`
export const SearchGoodsInput = () => {
    const onChangeSearchText = useOnChangeSearchText()
    const searchText = useSearchText()
    const search = useEvent(searchSuggestion)
    const isVisibleSuggestions = useStore($isOpenedSearchSection)
    const openSearchSectionHandler = useEvent(openSearchSection)
    const closeSearchSectionHandler = useEvent(closeSearchSection)
    const searchHandler = () => {
        search(searchText)
    }
    return (
        <Container>
            <SearchBlock>
                <SearchBlockMobile
                    searchHandler={searchHandler}
                    placeholder="Поиск на ЗДОРОВ.ру"
                    searchState={{
                        searchText,
                        focusHandler: openSearchSectionHandler,
                        changeSearchText: onChangeSearchText
                    }}
                />
                <ButtonTransparent
                    isVisible={isVisibleSuggestions}
                    colors={{
                        color: ThemeColors.getBlue60Color(0.8),
                        hoverColor: ThemeColors.getBlue60Color(0.6)
                    }}
                    data-cancel-suggest
                    clickHandler={closeSearchSectionHandler}>
                    Отмена
                </ButtonTransparent>
            </SearchBlock>
            <SuggestionsSearchBlock isVisible={isVisibleSuggestions}>
                <SuggestionsSearchMobile />
            </SuggestionsSearchBlock>
        </Container>
    )
}
